import { z } from 'zod';

export const phoneFormSchema = z.object({
  phone: z.string().nonempty({ message: 'errors.required-field' }),
  code: z.string(),
  firstOtp: z.string().optional(),
});

export type PhoneFormSchema = z.infer<typeof phoneFormSchema>;
